import { AddBox, Delete, Edit } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormLabel, InputLabel, MenuItem, Modal, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react"
import { toast } from "sonner";
import axiosInstance from "../../../utils/axiosInstance";

const Bookings = () => {
    const [bookings, setBookings] = useState([
        {
            booking_id: 0,
            user_id: '',
            user_name: '',
            user_type: '',
            instructor_name: '',
            instructor_id: '',
            date: '',
            start_time: '',
            end_time: '',
            duration: '',
        }
    ]);
    const [booking, setBooking] = useState({
        date: '',
        start_time: '',
        end_time: '',
        duration: '',
        instructor_id: '',
        user_id: '',
    });

    const [selectedBooking, setSelectedBooking] = useState({
        date: '',
        start_time: '',
        end_time: '',
        duration: '',
        instructor_id: '',
        user_id: '',
        booking_id: ''
    })
    const [searchQuery, setSearchQuery] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [participants, setParticipants] = useState([{
        role: '',
        name: '',
        participant_id: ''
    }]);
    const [instructors, setInstructors] = useState([{
        name: '',
        instructor_id: ''
    }]);

    const getBookingRef = useRef();

    const filteredBookings = bookings.filter((booking) =>
        booking.user_id.toLowerCase().includes(searchQuery.toLowerCase()) || booking.instructor.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const paginatedBookings = filteredBookings.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Delete confirmation handlers
    const handleOpenDeleteModal = (booking) => {
        setIsDeleteModalOpen(true);
        setSelectedBooking(booking)
    };

    const handleOpenEditModal = (booking) => {
        setIsEditModalOpen(true);
        setSelectedBooking(booking)
    };

    const handleDeleteBooking = async () => {
        await axiosInstance.delete(`bookings/delete/${selectedBooking.booking_id}2`).then(() => {
            toast.success(`Success, successfully deleted.`)
            setTimeout(() => {
                if (getBookingRef.current) getBookingRef.current();
                setIsDeleteModalOpen(false);
            }, 2000)
        }).catch((error) => {
            if (error.status === 404) {
                toast.error('Failure! booking not found')
            } else if (error.status === 400) {
                toast.error('Failure! Netork error, try again later')
            } else {
                toast.error('Failure! system is under maintenance. Please try again later')
            }
        })
    }

    const calculateDuration = (start, end) => {
        const [startHour, startMinute] = start.split(":").map(Number);
        const [endHour, endMinute] = end.split(":").map(Number);

        const startDate = new Date(0, 0, 0, startHour, startMinute);
        const endDate = new Date(0, 0, 0, endHour, endMinute);

        if (endDate < startDate) {
            endDate.setDate(endDate.getDate() + 1);
        }

        const diffInMs = endDate - startDate;
        const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
        const hours = Math.floor(diffInMinutes / 60);
        const minutes = diffInMinutes % 60;

        return `${hours}h ${minutes}m`;
    };

    const handleClose = () => {
        setIsAddModalOpen(false);
        if (getBookingRef.current) getBookingRef.current();
    }

    const bookSession = async () => {
        setBooking((prev) => ({ ...prev, duration: calculateDuration(booking.start_time, booking.end_time) }))

        await axiosInstance.post(`bookings/create`, booking, {
            headers: { 'Content-Type': 'application/json' }
        }).then(() => {
            toast.success(`Success, successfully booked a session.`)
            setTimeout(() => {
                handleClose();
            }, 2000)
        }).catch((error) => {
            if (error.response && error.response.data.error) {
                toast.error(`Failure, ${error.response.data.error}`)
            } else {
                toast.error(`Failure, ${error}`)
            }
        })
    }

    const handleEdit = async () => {
        const payload = {
            date: selectedBooking.date.slice(0, 10),
            start_time: selectedBooking.start_time,
            end_time: selectedBooking.end_time,
            duration: selectedBooking.duration,
            instructor_id: selectedBooking.instructor_id,
            user_id: selectedBooking.user_id,
        }

        await axiosInstance.put(`bookings/update/${selectedBooking.booking_id}`, payload, {
            headers: { 'Content-Type': 'application/json' }
        }).then(() => {
            toast.success(`Success, successfully edit.`)
            setTimeout(() => {
                if (getBookingRef.current) getBookingRef.current();
                setIsEditModalOpen(false);
            }, 2000)
        }).catch((error) => {
            if (error.response && error.response.data.error) {
                toast.error(`Failure, ${error.response.data.error}`)
            } else {
                toast.error(`Failure, ${error}`)
            }
        })
    }

    useEffect(() => {
        const getBookings = async () => {
            await axiosInstance.get(`bookings/all`).then((response) => {
                setBookings(response.data.bookings);
            }).catch(() => {
                setBookings([])
            })
        }

        const getParticipants = async () => {
            await axiosInstance.get(`auth/all_users`).then((response) => {
                setParticipants(response.data.users)
            }).catch(() => {
                setParticipants([])
            })
        }

        const getInstructors = async () => {
            await axiosInstance.get(`instructors/all`).then((response) => {
                setInstructors(response.data.instructors);
            }).catch((error) => {
                if (error.response && error.response.data.message === "No instructors found") {
                    setInstructors([]);
                } else if (error.response && error.response.data.message !== "No instructors found") {
                    setInstructors([]);
                } else {
                    setInstructors([]);
                }
            });
        }

        getBookingRef.current = getBookings;

        getBookings();
        getInstructors();
        getParticipants()
    }, [])

    const getClientName = (id) => {
        return participants.find((participant) => participant.guest_id || participant.member_id === id)?.name || '';
    }

    useEffect(() => {
        const duration = calculateDuration(booking.start_time, booking.end_time);
        setBooking((prev) => ({ ...prev, duration: duration }))
    }, [booking.start_time, booking.end_time])

    return (
        <div>
            <div className="md:flex justify-between md:flex-wrap">
                <Typography variant='h4' className="text-blue-800">Manage Bookings</Typography>
                <div className="mt-4 md:mt-0"><Button className="flex gap-3" variant="outlined" onClick={() => setIsAddModalOpen(true)}><AddBox /> Add Booking</Button></div>
            </div>
            <br />

            <div className="p-4">
                <TextField label="Search for a instructor by name, email" variant="outlined" fullWidth value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                <TableContainer component={Paper} className="shadow mt-4" sx={{ color: "#1f2937" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Instructor</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Start time</TableCell>
                                <TableCell>End time</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedBookings.map((booking, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{getClientName(booking.user_name)}</TableCell>
                                    <TableCell>{booking.instructor_name}</TableCell>
                                    <TableCell>{booking.date.slice(0, 10)}</TableCell>
                                    <TableCell>{booking.start_time.slice(0, 5)}</TableCell>
                                    <TableCell>{booking.end_time.slice(0, 5)}</TableCell>
                                    <TableCell>{booking.duration}</TableCell>
                                    {/* <TableCell>{dateFormat(user.created_at)}</TableCell> */}
                                    <TableCell className="flex gap-2">
                                        {/* <RemoveRedEye color="success" className="cursor-pointer" /> */}
                                        <Edit color="primary" onClick={() => handleOpenEditModal(booking)} className="cursor-pointer" />
                                        <Delete color="error" onClick={() => handleOpenDeleteModal(booking)} className="cursor-pointer" />
                                    </TableCell>
                                </TableRow>
                            ))}
                            {filteredBookings.length === 0 && <TableRow><TableCell colSpan={7} className="text-center">No booking found.</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, filteredBookings.length]}
                        component="div"
                        count={filteredBookings.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>

            {/* Delete Confirmation Modal */}
            <Dialog open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
                <DialogTitle className="text-blue-950">Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this booking
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDeleteModalOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteBooking} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit booking Modal */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm '>
                    <h2 className="text-blue-950 mb-8">Edit booking</h2>
                    <div>
                        <FormControl fullWidth style={{ marginBottom: 15 }}>
                            <InputLabel>Client</InputLabel>
                            <Select label="Select client" value={selectedBooking.user_id} onChange={(e) => setSelectedBooking((prev) => ({ ...prev, user_id: e.target.value }))}>
                                {participants.map((participant, index) =>
                                    <MenuItem key={index} value={participant.participant_id}>
                                        {participant.name} - <span className="text-blue-700 pr-2">{participant.role.toLocaleUpperCase()}</span>
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth style={{ marginBottom: 10 }}>
                            <InputLabel>Select Instructor</InputLabel>
                            <Select label="Select instructor" value={selectedBooking.instructor_id} onChange={(e) => setSelectedBooking((prev) => ({ ...prev, instructor_id: e.target.value }))}>
                                {instructors.map((instructor, index) =>
                                    <MenuItem key={index} value={instructor.instructor_id}>
                                        {instructor.name}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        <FormLabel>Schedule Date</FormLabel>
                        <TextField type='date' fullWidth variant="standard" value={selectedBooking.date.slice(0, 10)} onChange={(e) => setSelectedBooking((prev) => ({ ...prev, date: e.target.value }))} style={{ marginBottom: '16px' }} />
                        <FormLabel>Start Time</FormLabel>
                        <TextField type='time' fullWidth variant="standard" value={selectedBooking.start_time.slice(0, 5)} onChange={(e) => setSelectedBooking((prev) => ({ ...prev, start_time: e.target.value }))} style={{ marginBottom: '16px' }} />
                        <FormLabel>End Time</FormLabel>
                        <TextField type='time' fullWidth variant="standard" value={selectedBooking.end_time.slice(0, 5)} onChange={(e) => setSelectedBooking((prev) => ({ ...prev, end_time: e.target.value }))} style={{ marginBottom: '16px' }} />
                        <FormLabel>Duration: {selectedBooking.duration}</FormLabel>
                        <TextField type='text' fullWidth variant="standard" value={calculateDuration(selectedBooking.start_time, selectedBooking.end_time)} onChange={(e) => setSelectedBooking((prev) => ({ ...prev, duration: e.target.value }))} style={{ marginBottom: '16px' }} InputProps={{ readOnly: true }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsEditModalOpen(false)} color="secondary" fullWidth variant="outlined">
                            Cancel
                        </Button>
                        <Button color="primary" fullWidth variant="outlined" onClick={handleEdit}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Add Member Modal */}
            <Modal open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-6">Add booking</h2>
                    <FormControl fullWidth style={{ marginBottom: 15 }}>
                        <InputLabel>Client</InputLabel>
                        <Select label="Select client" value={booking.user_id} onChange={(e) => setBooking((prev) => ({ ...prev, user_id: e.target.value }))}>
                            {participants.map((participant, index) =>
                                <MenuItem key={index} value={participant.guest_id || participant.member_id}>
                                    {participant.name} - <span className="text-blue-700 pr-2">{participant.role.toLocaleUpperCase()}</span>
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: 10 }}>
                        <InputLabel>Select Instructor</InputLabel>
                        <Select label="Select instructor" value={booking.instructor_id} onChange={(e) => setBooking((prev) => ({ ...prev, instructor_id: e.target.value }))}>
                            {instructors.map((instructor, index) =>
                                <MenuItem key={index} value={instructor.instructor_id}>
                                    {instructor.name}
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormLabel>Schedule Date</FormLabel>
                    <TextField type='date' fullWidth variant="standard" value={booking.date} onChange={(e) => setBooking((prev) => ({ ...prev, date: e.target.value }))} style={{ marginBottom: '16px' }} />
                    <FormLabel>Start Time</FormLabel>
                    <TextField type='time' fullWidth variant="standard" value={booking.start_time} onChange={(e) => setBooking((prev) => ({ ...prev, start_time: e.target.value }))} style={{ marginBottom: '16px' }} />
                    <FormLabel>End Time</FormLabel>
                    <TextField type='time' fullWidth variant="standard" value={booking.end_time} onChange={(e) => setBooking((prev) => ({ ...prev, end_time: e.target.value }))} style={{ marginBottom: '16px' }} />
                    <div className='flex gap-4 mx-auto w-[100%] mt-4'>
                        <Button variant="contained" color="primary" onClick={bookSession}>
                            Book a session
                        </Button>
                        <Button variant="contained" color="error" onClick={handleClose} className='w-48'>
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default Bookings